export default {
    start: 0,
    limit: 10
}